import React, { Component } from "react";
import "react-table/react-table.css";
import Pagination from "./Pagination.js";
import { InlineLoading } from "./Loading.js";
import "./tableFreeze.css";
function Row({ data, index }) {
  const dataArray = Object.values(data);
  return (
    <tr>
      {dataArray.map((value, i) => {
        return (
          <td key={i} className={i == 0 ? "headcol" : "headleft"}>
            {value}
          </td>
        );
      })}
    </tr>
  );
}

export class TableILPDewasa extends Component {
  state = {
    currentPage: 1,
    from: 0,
    searchInput: "",
    data: this.props.datas,
    issearch: this.props.issearch ? true : false,
    allData: this.props.datas,
    allDataBefore: this.props.datas,
  };

  handlePageChange = (pageNumber) => {
    this.setState((prevState) => {
      return {
        currentPage: pageNumber,
        from: (pageNumber - 1) * 10,
      };
    });
  };

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      this.setState({
        currentPage: 1,
        from: 0,
        allData: this.props.data,
        data: this.props.data,
      });
    }
  }
  handleChange = (event) => {
    this.setState({ searchInput: event.target.value }, () => {
      this.globalSearch();
    });
  };

  globalSearch = () => {
    let search = this.props.search;
    let { searchInput } = this.state;
    let filteredDatas = this.state.allData;
    if (!searchInput || searchInput == "") {
      filteredDatas = this.state.allDataBefore;
    } else {
      filteredDatas = filteredDatas
        ? this.state.allData.filter((value) => {
            return eval(search);
          })
        : [];
    }
    this.setState({ data: filteredDatas });
    this.props.filteredData ? this.props.filteredData({ filteredDatas }) : null;
  };
  render() {
    const currentPage = this.state.currentPage;
    const {
      headers,
      pagination = true,
      aggregate,
      isLoading,
      listsPerPage = 10,
      isBordered = false,
      label = null,
    } = this.props;
    const datas = this.state.data
      ? this.state.data.map(this.props.columnMapper)
      : [];
    const indexOfLastPost = this.state.currentPage * listsPerPage;
    const indexOfFirstPost = indexOfLastPost - listsPerPage;
    const currentLists = pagination
      ? datas
        ? datas.slice(indexOfFirstPost, indexOfLastPost)
        : []
      : datas;
    let { searchInput } = this.state;
    return (
      <div>
        {this.state.issearch ? (
          <div className="form-group">
            <div className="input-group">
              <div className="input-group-prepend">
                <span
                  className="input-group-text text-default"
                  id="basic-addon1"
                >
                  Filter Data
                </span>
              </div>
              <input
                type="text"
                className="form-control"
                aria-describedby="basic-addon1"
                name="searchInput"
                value={searchInput || ""}
                onChange={this.handleChange}
              />
            </div>
          </div>
        ) : (
          ""
        )}
        <div
          className="table-responsive"
          style={{
            maxHeight: "500px",
            overflowY: "auto",
          }}
        >
          <table
            className={`table align-items-center table-${
              isBordered ? "bordered" : "flush"
            } `}
          >
            <thead className="thead-light">
              <tr>
                <th
                  className="text-center bg-purple text-white text-bold"
                  colSpan={headers.length}
                >
                  {label}
                </th>
              </tr>
              <tr>
                {headers.map((header, i) => {
                  return (
                    <th
                      key={i}
                      scope="col"
                      className={i == 0 ? "sort headcol" : "sort headleft"}
                      style={{
                        position: "sticky",
                        top: 0,
                        zIndex: 1,
                      }}
                    >
                      {header}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody className="list">
              {isLoading ? (
                <tr>
                  <td colSpan={headers.length} style={{ textAlign: "center" }}>
                    <InlineLoading isLoading={isLoading} />
                  </td>
                </tr>
              ) : currentLists.length > 0 ? (
                currentLists.map((currentList, i) => {
                  return (
                    <Row
                      key={i}
                      data={currentList}
                      index={this.state.from + i + 1}
                    />
                  );
                })
              ) : (
                <tr>
                  <td colSpan={headers.length} style={{ textAlign: "center" }}>
                    tidak ada data..
                  </td>
                </tr>
              )}
              {currentLists.length > 0 && aggregate ? (
                <tr>{aggregate(this.props.data)}</tr>
              ) : null}
            </tbody>
          </table>
          {pagination && !isLoading ? (
            <Pagination
              listsPerPage={listsPerPage}
              totalLists={datas && datas.length}
              handlePageChange={this.handlePageChange}
              currentPage={currentPage}
            />
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}

export default TableILPDewasa;
